import { ContactType } from '@features/contacts/types/contactType'
import type { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'

export const demoInvoicingSettingsInvoiceReceiver: InvoiceFormReceiver = {
  cityText: 'City',
  contactNo: '1212',
  countryId: 'FR',
  ean: '',
  externalId: '4725824',
  id: '',
  name: '',
  paymentTermsDays: 14,
  phone: '',
  registrationNo: '',
  street: 'John Doe Street 12',
  type: ContactType.Company,
  vatNo: '',
  zipcodeText: '11-111',
}
